export default "__VITE_ASSET__DqwAX3w9__"